import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Form, Input, Select, Space, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import { addressSearch } from '../../services/postservice'
import FormPost from './FormPost'
import {
  ACTION_MODE,
  OPTIONS_STATUS_NOTIFICATION,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  departmentSearch,
  getNotificationManager,
  getSystemManager,
  notificationDetail,
  notificationManagerAdd,
  notificationManagerUpdate,
  notificationStatus
} from '../../services/cmsservice'
import dayjs from 'dayjs'
import { listFooter } from '../../services/footer-service'
import { getSubProductType, ProductType } from '../PostManagement/configs'
import TableA from './components/TableA'
import TableB from './components/TableB'
import TableC from './components/TableC'
import TableD from './components/TableD'
import Loading from '../Loading';

const FooterManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      title: filters.title || '',
      status: filters.status || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await listFooter(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      // dataIndex: 'id',
      // key: 'id'
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label'
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type'
    },
    {
      title: 'Loại hình ',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate'
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      render: (_, record) => {
        return <>{record.district_info.name}</>
      }
    },

    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      render: (_, record) => {
        return <>{record.city_info.name}</>
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space size="small">
            {record.status == 1 && (
              <Tooltip title="Xem chi tiết">
                <Button
                  style={{ width: 32 }}
                  icon={<EyeOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.VIEW)
                    getDetailNotification(record.id)
                  }}
                />
              </Tooltip>
            )}
            {record.status == 0 && (
              <>
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      getDetailNotification(record.id)
                    }}
                  />
                </Tooltip>

                <Tooltip title="Hủy">
                  <Button
                    // style={{ width: 32 }}
                    // icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận hủy',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn hủy
                            {/* <b> {record.project_name}</b> không? */}
                          </div>
                        ),
                        onOk: () => handleChangeStatus(2, record.id)
                      })
                    }
                  >
                    {' '}
                    Hủy
                  </Button>
                </Tooltip>
              </>
            )}
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res =
        mode == ACTION_MODE.ADD
          ? await notificationManagerAdd(data)
          : await notificationManagerUpdate(data, id)

      console.log('rerrrrrrr', res)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới thông báo thành công !'
          : 'Cập nhật thông báo thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Chi tiết dự án
  const getDetailNotification = async (id) => {
    setLoading(true)
    try {
      const res = await notificationDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        const normalizedValue =
          values.departments_id === '""' ? '' : Number(values.departments_id)

          form.setFieldsValue({
          ...values,
          date_sent: dayjs(values.date_sent),
          departments_id: normalizedValue,
          permission: JSON.parse(values.permission),
          users_id: JSON.parse(values.users_id)
        })
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      console.error('Error fetching roles:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleChangeStatus = async (status, id) => {
    setLoading(true)
    try {
      const res = await notificationStatus(status, id)
      if (res && res.data) {
        openNotification('success', 'Cập nhật thành công')
        fetchData()
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      console.log('err', err)
    } finally {
      setLoading(false)
    }
  }

  // CITY
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {}
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {}
  }

  useEffect(() => {
    getListCities()
  }, [])

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code
  }
  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e)
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }
  return (
    <div>
      <Loading loading={loading} />
      <TableA />
      <TableB />
      <TableC />
      <TableD />
      {/* Modal Thêm mới sản phẩm */}
      <ModalConfirm />
    </div>
  )
}

export default FooterManagement
